import React from 'react';
import SuccessFilledIcon from '../../../visuals/Icons/SuccessFilled';
import references from '../../../css-library/tokens/reference';
import { IconSizes } from '../../../visuals/Icons/type';
import { useTextInput } from '../TextInput/TextInput';

interface ISuccessTextProps {
  children: React.ReactNode;
}

export const SuccessText: React.FC<ISuccessTextProps> = ({ children }) => {
  const { isValid } = useTextInput();

  return (
    <span
      className={`tw-grid-area-[text] tw-lf-form-input-bottom-message ${
        isValid ? 'tw-flex' : 'tw-hidden'
      } peer-[:not(:placeholder-shown)]:peer-valid:tw-flex group-[.text-input-action]:tw-ml-2`}
    >
      <SuccessFilledIcon
        color={references.colors.green[600]}
        size={IconSizes.sm}
      />
      <span className="tw-lf-input-success-message">{children}</span>
    </span>
  );
};
